export enum SubPointType {
  END_NEG = 'END_NEG',
  END_POS = 'END_POS',
  START_NEG = 'START_NEG',
  START_POS = 'START_POS'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/subpointtype.ts